"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseURI = exports.uriToString = void 0;
var shared_1 = require("@cian/peperrors/shared");
var url_parse_1 = __importDefault(require("url-parse"));
/**
 * Утилита для преобразования URI в строку
 * Является копией старого класса URI
 *
 * @export
 * @param {IURIPartial} uri
 * @returns {string}
 */
function uriToString(uri) {
    var portFragment = isPortStandard(uri.scheme, uri.port) ? '' : ':' + String(uri.port);
    var hostFragment = uri.host + portFragment;
    var schemeFragment = "".concat(uri.scheme || 'https', "://");
    var pathFragment = uri.path === '' ? '/' : uri.path;
    var searchFragment = !uri.query ? '' : '?' + uri.query;
    return schemeFragment + hostFragment + pathFragment + searchFragment;
}
exports.uriToString = uriToString;
function isPortStandard(scheme, port) {
    if (!port) {
        return true;
    }
    return (scheme === 'https' && port === 443) || (scheme === 'http' && port === 80);
}
function parseURI(str) {
    var _a;
    var result = (0, url_parse_1.default)(str);
    var scheme = result.protocol.replace(':', '');
    var defaultPort = scheme === 'http' ? 80 : 443;
    if (!((_a = result.hostname) === null || _a === void 0 ? void 0 : _a.length) || !['http', 'https'].includes(scheme)) {
        throw new shared_1.ValidationError({ message: "Invalid uri ".concat(str), domain: 'http-api.URIParser.validate' });
    }
    return {
        host: result.hostname,
        path: result.pathname || '/',
        port: Number(result.port || defaultPort),
        //Неверное описание типа в тайпингах url-parse
        query: result.query,
        scheme: scheme,
    };
}
exports.parseURI = parseURI;
//# sourceMappingURL=parsers.js.map